import React, { Component } from 'react'
import './GSTDetails.css'
// let gst = 'Details not available'
class GSTDetails extends Component {
    constructor(props) {
        super(props)

        this.state = {
            gst: 'Details not available'
        }
    }

    // componentWillReceiveProps(nextProps){
    //     gst=nextProps.transporter_data.gst;
    //     if(gst==undefined || gst==null){
    //         gst='Details not available'
    //     }
    // }
    static getDerivedStateFromProps(nextProps, prevState) {
        // gst=nextProps.transporter_data.gst;
        // if(gst==undefined || gst==null){
        //     gst='Details not available'
        // }
        if (nextProps.transporter_data.gst === undefined || nextProps.transporter_data.gst === null) {
            return {
                gst: 'Details not available'
            }
        }
        else {
            return {
                gst: nextProps.transporter_data.gst
            }
        }
    }

    render() {
        const { gst } = this.state
        if (gst.gst_registered === "yes" || gst.gst_registered === "Yes" || gst.gst_registered === "1" || gst.gst_registered === 1) {
            return (
                <>
                    <div className="gstcard">
                        <div className="gstcontainer row">
                            <div className="col-12">
                                <span className="data_header"><b>Goods and Services Tax(GST)</b></span>
                            </div>
                            { (gst === 'Details not available')?(<div><b>Details not available</b></div>):(
                            <div className="col">
                                <div>
                                {(gst.forward_charging_mechanism==="yes" || gst.forward_charging_mechanism==="Yes" || gst.forward_charging_mechanism==="1" || gst.forward_charging_mechanism===1)?<span className="gst">
                                <b>Forward Charging Mechanism</b>
                                </span> :
                                null}
                                {/* <div> */}
                                {(gst.reverse_charging_mechanism==="yes" || gst.reverse_charging_mechanism==="Yes" || gst.reverse_charging_mechanism==="1" || gst.reverse_charging_mechanism===1)?<span className="gst">
                                <b>Reverse Charging Mechanism</b>
                                </span> :
                                null}
                                {/* </div> */}
                                </div>
                            <div style={{ fontSize: '14px'}} className="gst"><b>GST No: </b>{gst.gst_number}</div>
                            </div>)}
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (
                <>
                    <div className="gstcard">
                        <div className="gstcontainer row">
                            <div className="col-12">
                                <span className="data_header"><b>Goods and Services Tax(GST)</b></span>
                            </div>
                            {(gst === 'Details not available') ? (<div><span>Details not available</span></div>) : (<div className="col">
                                <div className="gst"><span>Goods Transport Agency(GTA)</span></div>
                                <div className="gst">{gst.transportation_id}</div>
                            </div>)}
                        </div>
                    </div>
                </>)

        }
    }
}

export default GSTDetails
